module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'primary': '#000000',
                    'secondary': '#ffffff',
                }
            },
        },
        fontFamily: {
            centuryGothic: ['Century Gothic', 'sans-serif'],
            opsGrotesko: ["OPS Grotesko", 'sans-serif']
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('tailwind-scrollbar'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
